<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--처리상태-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001043') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!--PWA No.-->
							<th class="col-1">PWA No.</th>
							<td class="col-1">
								<el-input v-model="pwaNo" readonly></el-input>
							</td>
							<!--처리단계-->
							<th class="col-1">{{ getMessage_('QWCC000963') }}</th>
							<td class="col-1">
								<el-input v-model="prcsStepNm" readonly />
							</td>
							<!--신청일-->
							<th class="col-1">{{ getMessage_('QWCC000979') }}</th>

							<td class="col-1">
								<el-input v-model="aplcDd" readonly />
							</td>
							<!--확정일-->
							<th class="col-1">{{ getMessage_('QWCC000980') }}</th>
							<td class="col-1">
								<el-input v-model="dcsnDd" readonly />
							</td>
							<th class="col-1" />
							<td class="col-1" />
						</tr>
						<tr>
							<th class="col-1">Ro No.</th>
							<td class="col-1"><el-input v-model="roNo" readOnly /></td>
							<!--처리단계-->
							<th class="col-1">{{ getMessage_('QWCC000963') }}</th>
							<td class="col-1">
								<el-input v-model="prcsStepNmr" readOnly />
							</td>
							<!--신청일-->
							<th class="col-1">{{ getMessage_('QWCC000979') }}</th>

							<td class="col-1">
								<el-input v-model="aplcDdr" readOnly />
							</td>
							<!--확정일-->
							<th class="col-1">{{ getMessage_('QWCC000980') }}</th>
							<td class="col-1">
								<el-input v-model="dcsnDdr" readOnly />
							</td>
							<th class="col-1" />
							<td class="col-1" />
						</tr>
						<tr>
							<!--캠페인No-->
							<th class="col-1">{{ getMessage_('QWCC001024') }}</th>
							<td class="col-1"><el-input v-model="cmpnNo" readOnly /></td>
							<!--캠페인명-->
							<th class="col-1">{{ getMessage_('QWCC001007') }}</th>
							<td class="col-1">
								<el-input v-model="cmpnNm" readonly />
							</td>
							<!--op코드-->
							<th class="col-1">{{ getMessage_('QWCC001096') }}</th>

							<td class="col-1">
								<el-input v-model="opCd" readOnly />
							</td>

							<!--OP코드명-->
							<th class="col-1">{{ getMessage_('QWCC001807') }}</th>
							<td class="col-1"><el-input v-model="opNm" readOnly /></td>

							<th class="col-1"></th>
							<td class="col-1"></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
export default {
	props: {
		scrId: { type: String, default: '' },
		sendParam5: { type: Object }
	},
	components: {},
	data() {
		return {
			roNo: '', //roNo
			prcsStepr: '',
			prcsStepNmr: '',
			aplcDdr: '',
			dcsnDdr: '',
			pwaNo: '', //pwqNo
			prcsStepNm: '',
			prcStep: '',
			aplcDd: '',
			dcsnDd: '',
			cmpnNo: '',
			cmpnNm: '',
			opCd: '',
			opNm: ''
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		chgFlag() {
			return this.getIsSaveFlag_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,

		setProcessInfo() {
			this.roNo = this.clamMstPopUp.roNo; // ro번호
			this.prcsStepr = this.clamMstPopUp.prcsStepr; //ro상태코드
			this.prcsStepNmr = this.clamMstPopUp.prcsStepNmr; //ro상태코드명
			this.aplcDdr = this.clamMstPopUp.aplcDdr; //rp신청일
			this.dcsnDdr = this.clamMstPopUp.dcsnDdr; //ro확정일

			this.pwaNo = this.clamMstPopUp.pwaNo; //pwaNo
			this.prcsStepNm = this.clamMstPopUp.prcsStepNm; //pwa처리단계명
			this.aplcDd = this.clamMstPopUp.aplcDd; //pwa처리일자
			this.dcsnDd = this.clamMstPopUp.dcsnDd; //pwa확정일자

			this.cmpnNo = this.clamMstPopUp.cmpnNo; //캠페인번호
			this.cmpnNm = this.clamMstPopUp.cmpnNm; //캠페인명
			this.opCd = this.clamMstPopUp.opCd; //캠페인 opCode
			this.opNm = this.clamMstPopUp.opNm; //캠페인 opCode명
		}
	},
	async created() {
		//스토어에서 값을 가져와서 셋팅한다.
		this.roNo = this.clamMstPopUp.roNo; // ro번호
		this.prcsStepr = this.clamMstPopUp.prcsStepr; //ro상태코드
		this.prcsStepNmr = this.clamMstPopUp.prcsStepNmr; //ro상태코드명
		this.aplcDdr = this.clamMstPopUp.aplcDdr; //rp신청일
		this.dcsnDdr = this.clamMstPopUp.dcsnDdr; //ro확정일

		this.pwaNo = this.clamMstPopUp.pwaNo; //pwaNo
		this.prcsStepNm = this.clamMstPopUp.prcsStepNm; //pwa처리단계명
		this.aplcDd = this.clamMstPopUp.aplcDd; //pwa처리일자
		this.dcsnDd = this.clamMstPopUp.dcsnDd; //pwa확정일자
		this.cmpnNo = this.clamMstPopUp.cmpnNo; //캠페인번호
		this.cmpnNm = this.clamMstPopUp.cmpnNm; //캠페인명
		this.opCd = this.clamMstPopUp.opCd; //캠페인 opCode
		this.opNm = this.clamMstPopUp.opNm; //캠페인 opCode명
	},
	watch: {
		chgFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.getIsSaveFlag_) {
				this.setStateClamSave_({ key: 'roNo', value: convertNvl(this.roNo, '') }); // ro번호
			}
		}
	}
};
</script>

<style>
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
	top: -3px;
}
</style>
